var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useEffect, useContext } from 'react';
import { Typography, Link } from '@one-thd/sui-atomic-components';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { getNativeStoreID, scrollToTop, smoothScroll, } from '../../utils/general';
import { SectionHeader } from '../shared/section-header/section-header';
import { StaticField } from '../shared/static-field/static-field';
import { addressesApi } from '../../api/common/addresses';
import { useProfile } from '../../hooks/use-profile';
import { getLocalizedStoreId } from '../../utils/store';
import Spinner from '../shared/spinner/spinner';
var convertTo12HrFormat = function (hhmm) {
    if (hhmm && hhmm.split(':').length && hhmm.split(':').length === 2) {
        var hoursStr = hhmm.split(':')[0];
        var minStr = hhmm.split(':')[1];
        var hoursInt = parseInt(hoursStr, 10);
        if (hoursInt === 0) {
            return "12".concat(':').concat(minStr, " a.m.");
        }
        if (hoursInt < 12) {
            return "".concat(hoursStr).concat(':').concat(minStr, " a.m.");
        }
        if (hoursInt === 12) {
            return "".concat(hoursStr).concat(':').concat(minStr, " p.m.");
        }
        var pmHoursString = (hoursInt - 12).toString();
        return "".concat(pmHoursString).concat(':').concat(minStr, " p.m.");
    }
    return hhmm;
};
export var MyStore = function () {
    var _a, _b, _c, _d, _e, _f;
    var _g = useContext(ExperienceContext), channel = _g.channel, isConsumerApp = _g.isConsumerApp;
    var isMobile = channel === 'mobile';
    var profileValues = useProfile();
    var profileStoreId = (_a = profileValues.customerData) === null || _a === void 0 ? void 0 : _a.localStoreId;
    var storeId = (isConsumerApp && getNativeStoreID()) ||
        (!isConsumerApp && getLocalizedStoreId()) ||
        profileStoreId ||
        '';
    var _h = useState(undefined), storeInfo = _h[0], setStoreInfo = _h[1];
    var _j = useState(true), isLoading = _j[0], setLoading = _j[1];
    useEffect(function () {
        smoothScroll();
        var ignore = false;
        if (storeId) {
            setLoading(true);
            addressesApi
                .getStore(storeId)
                .then(function (data) {
                if (!ignore) {
                    setStoreInfo(data === null || data === void 0 ? void 0 : data.stores[0]);
                }
            })
                .finally(function () {
                if (!ignore) {
                    setLoading(false);
                }
            });
        }
        return function () {
            ignore = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var _k = (_b = storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.storeHours) !== null && _b !== void 0 ? _b : {}, monday = _k.monday, tuesday = _k.tuesday, wednesday = _k.wednesday, thursday = _k.thursday, friday = _k.friday, saturday = _k.saturday, sunday = _k.sunday;
    var mon = __assign({ name: 'Monday' }, monday);
    var tue = __assign({ name: 'Tuesday' }, tuesday);
    var wed = __assign({ name: 'Wednesday' }, wednesday);
    var thu = __assign({ name: 'Thursday' }, thursday);
    var fri = __assign({ name: 'Friday' }, friday);
    var sat = __assign({ name: 'Saturday' }, saturday);
    var sun = __assign({ name: 'Sunday' }, sunday);
    var daysOfTheWeek = [mon, tue, wed, thu, fri, sat, sun];
    var normalDays = [];
    var irregularDays = [];
    daysOfTheWeek.slice(0, daysOfTheWeek.length).forEach(function (day) {
        var hasIrregularHours = (day === null || day === void 0 ? void 0 : day.open) &&
            (day === null || day === void 0 ? void 0 : day.close) &&
            ((day === null || day === void 0 ? void 0 : day.open) !== (mon === null || mon === void 0 ? void 0 : mon.open) || (day === null || day === void 0 ? void 0 : day.close) !== (mon === null || mon === void 0 ? void 0 : mon.close));
        if (hasIrregularHours) {
            irregularDays.push(day);
        }
        else if (irregularDays.length === 0) {
            normalDays.push(day);
        }
        else {
            irregularDays.push(day);
        }
    });
    var getOpenCloseHours = function (day) {
        if ((day === null || day === void 0 ? void 0 : day.open) === (day === null || day === void 0 ? void 0 : day.close)) {
            return 'Closed';
        }
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return "".concat(convertTo12HrFormat(day.open), " - ").concat(convertTo12HrFormat(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        day.close));
    };
    var getOpenCloseLabel = function (day, day2) {
        if (day2) {
            return "".concat(day === null || day === void 0 ? void 0 : day.name.substring(0, 3), " - ").concat(day2 === null || day2 === void 0 ? void 0 : day2.name.substring(0, 3), ": ");
        }
        return "".concat(day === null || day === void 0 ? void 0 : day.name.substring(0, 3), ": ");
    };
    var getOpenCloseBlock = function (day, day2) {
        return isMobile ? (React.createElement("div", { key: day.name, className: "sui-flex sui-flex-col sm:sui-block" },
            React.createElement(Typography, { weight: "bold", variant: "body-base" }, getOpenCloseLabel(day, day2)),
            React.createElement(Typography, { weight: "regular", variant: "body-base" }, getOpenCloseHours(day)))) : (React.createElement("div", { key: day.name },
            React.createElement(Typography, { weight: "regular", variant: "body-base" },
                getOpenCloseLabel(day, day2),
                getOpenCloseHours(day))));
    };
    var navigateToStoreSearch = function () {
        scrollToTop();
        var openLocDrawer = new Event('launchLocDrawer');
        document.dispatchEvent(openLocDrawer);
    };
    var storeTitle = "".concat(storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.name, ", #").concat(storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.storeId);
    var storeStreet = "".concat((_c = storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.address) === null || _c === void 0 ? void 0 : _c.street);
    var storeCity = "".concat((_d = storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.address) === null || _d === void 0 ? void 0 : _d.city, ", ").concat((_e = storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.address) === null || _e === void 0 ? void 0 : _e.state, " ").concat((_f = storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.address) === null || _f === void 0 ? void 0 : _f.postalCode);
    if (!storeInfo) {
        return React.createElement(Spinner, { active: isLoading });
    }
    var formatPhone = function (phone) {
        var splitPhone = phone.split('(')[1].split(')');
        return splitPhone.join('-');
    };
    return (React.createElement("div", null,
        isMobile ? (React.createElement(React.Fragment, null,
            React.createElement(SectionHeader, { title: "YOUR STORE", dataTestIdTitle: "ProfileMyStore" }),
            React.createElement("div", { className: "sui-flex sui-justify-between sui-mb-2" },
                React.createElement(Typography, { variant: "h4", weight: "display" }, storeTitle),
                !isConsumerApp && (React.createElement(Link, { onClick: navigateToStoreSearch, "data-testid": "ProfileMyStoreChangeYourStore" }, "Change Your Store"))))) : (React.createElement(React.Fragment, null,
            React.createElement(SectionHeader, { title: "YOUR STORE", actionLabel: !isConsumerApp ? 'Change Your Store' : undefined, onActionClick: navigateToStoreSearch, dataTestIdBtn: "ProfileMyStoreChangeYourStore", dataTestIdTitle: "ProfileMyStore" }),
            React.createElement(StaticField, { title: storeTitle, content: "", isOneLiner: true }))),
        React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-4 sm:sui-gap-2 sui-mb-2" },
            isMobile ? (React.createElement(React.Fragment, null,
                React.createElement("div", null, !isConsumerApp ? (React.createElement(Link, { href: "/l/search/".concat(storeId, "?view=map"), underline: "always", "data-testid": "ProfileMyStoreViewMap" }, "".concat(storeStreet, ", ").concat(storeCity))) : (React.createElement("span", null, "".concat(storeStreet, ", ").concat(storeCity)))),
                (storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.phone) && (React.createElement("div", { className: "sui-flex sui-flex-col" },
                    React.createElement(Typography, { weight: "bold" }, "Phone: "),
                    React.createElement(Link, { href: "tel:".concat(formatPhone(storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.phone)) }, formatPhone(storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.phone)))),
                (storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.proDeskPhone) && (React.createElement("div", { className: "sui-flex sui-flex-col" },
                    React.createElement(Typography, { weight: "bold" }, "Pro Phone: "),
                    React.createElement(Link, { href: "tel:".concat(formatPhone(storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.proDeskPhone)) }, formatPhone(storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.proDeskPhone)))))) : (React.createElement(React.Fragment, null,
                React.createElement("div", null,
                    React.createElement(Typography, { weight: "regular", variant: "body-base", "data-testid": "ProfileMyStoreAddressDetails" }, storeStreet)),
                React.createElement("div", null,
                    React.createElement(Typography, { weight: "regular", variant: "body-base" }, storeCity)),
                (storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.phone) && (React.createElement("div", null,
                    React.createElement(Typography, { weight: "regular", variant: "body-base" },
                        "Phone: ",
                        formatPhone(storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.phone)))),
                (storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.proDeskPhone) && (React.createElement("div", null,
                    React.createElement(Typography, { weight: "regular", variant: "body-base" },
                        "Pro Phone: ",
                        formatPhone(storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.proDeskPhone)))))),
            normalDays.length === 1 && getOpenCloseBlock(mon),
            normalDays.length > 1 &&
                getOpenCloseBlock(normalDays[0], normalDays.slice(-1)[0]),
            irregularDays.map(function (day) { return getOpenCloseBlock(day); })),
        !isConsumerApp && (storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.url) && (React.createElement("div", { className: "sui-mt-7 sm:sui-mt-0" },
            React.createElement(Link, { underline: "always", href: storeInfo.url, "data-testid": "ProfileMyStoreStoreDetails" }, "View Store Details")))));
};
